import React, { useCallback, useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useLocation, useNavigate, useParams, Link } from 'react-router-dom';
import useFetch from '../../hooks/useFetch';
import "./styles/AICounselling.css";
import AICounsellingImage from '../../assets/pageimages/AICounselling.webp';

const AICounsellingAbout = () => {
    const menuItems = [
        { id: "why-aicounselling", label: "Why AI Counselling", icon: "🤖" },
        { id: "ideal-for", label: "Useful For", icon: "🎯" },
        { id: "students", label: "Students", icon: "🎓" },
        { id: "teachers", label: "Teachers", icon: "📚" },
        { id: "parent", label: "Parents", icon: "👨‍👩‍👧" },
        { id: "mothers", label: "Mothers", icon: "🤱" },
        { id: "farmers", label: "Farmers", icon: "🌾" },
        { id: "workers", label: "Workers", icon: "👷‍♂️" },
        { id: "msmeowners", label: "MSME Owners", icon: "🏭" },
        { id: "managers", label: "Managers", icon: "🧑‍💼" },
        { id: "professionals", label: "Professionals", icon: "💼" },
        { id: "governemnt", label: "Government", icon: "🏛️" },
        { id: "psychometric-questions", label: "Psychometric Questions", icon: "🧠" },
        { id: "tests-and-preparation", label: "Tests & Preparation", icon: "📝" },
        { id: "progress-tracker", label: "Progress Tracker", icon: "📊" },
        { id: "example-milestones", label: "Example Milestones", icon: "🚀" },
        { id: "rca", label: "RCA", icon: "🔍" },
        { id: "interview-practice", label: "Interview Practice with AI", icon: "🎤" },
        { id: "ai-assessment", label: "AI Assessment", icon: "📈" },
        { id: "historical-data", label: "Historical Data", icon: "📜" },
        { id: "plans", label: "Plans", icon: "🗂️" },
        { id: "workflow", label: "Workflow", icon: "🔄" },
        ];

      return (
        <div className="from-black text-white text-sm">
            <header
                className="
                    sticky top-0 z-50 
                    bg-black 
                    px-4 py-3 
                    flex flex-col items-center justify-center
                    shadow-md border-b border-gray-800
                "
                >
                <div className="flex flex-row gap-4 items-center justify-center">
                    
                    <img
                    src={AICounsellingImage}
                    alt="MyProfile Image"
                    style={{ height: "100px" }}
                    className="rounded-lg shadow-lg"
                    />
                    <div className="flex flex-col items-center mt-2 p-4">
                        <h1 className="text-xl text-yellow-200 mt-1">Think5Whys AI Counsellor</h1>
                    </div>
                </div>
            </header>

            <nav id="main-menu" className="bg-black py-2 shadow-sm">
                <div className="flex flex-col justify-center items-center py-4 text-center space-y-0">
                    <p className="flex-1 items-center text-xs lg:text-xl font-bold">Think5Whys AI Counselling: Bringing Kaizen with AI-Supported Counselling.</p>
                    <p className="flex-1 items-center text-blue-300 text-sm">Empowering Community including Teachers, Parent, Students, Farmers, MSME Onwers, Employees, Professionals and all.</p>
                    <p className="text-white text-sm">Simple data science on a day-to-day basis.</p>
                    <p className="text-teal-500 text-sm">A blend of modern technology & human interaction.</p>
                </div>
                <div className="text-sm px-4 
                grid grid-cols-3 md:grid-cols-3 lg:grid-cols-7 
                gap-3 sm:gap-4 w-full place-items-center">

                {menuItems.map((item) => (
                    <a
                    key={item.id}
                    href={`#${item.id}`}
                    className="w-full bg-black text-yellow-200 border border-blue-500 
                                py-3 px-4 rounded-lg 
                                flex flex-col sm:flex-row justify-center items-center gap-2 
                                font-semibold text-center
                                hover:bg-blue-600 hover:text-white 
                                transition-all duration-300 ease-in-out hover:scale-105"
                    >
                    <span className="text-lg">{item.icon}</span>
                    <span className="text-xs sm:text-sm">{item.label}</span>
                    </a>
                ))}
                </div>

            </nav>

            <section id="why-aicounselling" className="bg-black border border-blue-400 text-white p-4 text-sm">
                <div className='px-4'>
                    <h3 className="text-xl font-semibold mb-2">Think5Whys AI Insights</h3>
                    <p className='text-sm'>Think5Whys AI Insights can act as a bridge between academic preparation and competitive exam readiness, giving students a clear picture of where they stand and what steps they need to take.</p>
                    <ul className="list-disc ml-6 space-y-1">
                        <li>Strengths in specific subjects</li>
                        <li>Weak areas to work on</li>
                        <li>Recommendations for competitive exam prep aligned with the academic syllabus</li>
                        <li>Organized Interview Prep</li>
                    </ul>
                </div>
                <div className='mt-2 px-4 text-sm'>
                    <h3 className="text-lg font-semibold mb-2">Teacher/Parent Dashboard</h3>
                    <p className='text-sm'>Teachers/parents can view the student’s progress to provide additional support.</p>
                </div>
                <div className='mt-2 px-4'>
                    <h3 className="text-lg font-semibold mb-2">How Students Will Benefit</h3>
                    <ul className="list-disc ml-6 space-y-1 text-sm">
                    <li><strong>Personalized Guidance:</strong> Tailored suggestions for academics, career, and well-being.</li>
                    <li><strong>Flexibility:</strong> Choose the plan that suits your lifestyle and budget.</li>
                    <li><strong>Advanced AI:</strong> Powered by cutting-edge AI algorithms for accurate and effective counselling.</li>
                    <li><strong>Accessible Anytime, Anywhere:</strong> On your desktop, tablet, or mobile.</li>
                    <li><strong>Stay Organized:</strong> Maintain a structured record of their performance.</li>
                    <li><strong>Self-Evaluation:</strong> Continuously evaluate their academic readiness.</li>
                    <li><strong>Motivation:</strong> See tangible progress and feel encouraged to improve.</li>
                    <li><strong>Bridge Gaps:</strong> Address weak areas proactively before competitive exams.</li>
                    <li><strong>Data-Driven Prep:</strong> Use past performance data to optimize competitive exam preparation.</li>
                    </ul>
                </div>
                <div className="mt-2">
                    <a href="#main-menu" className="text-yellow-200 underline hover:text-yellow-300">Go to Menu</a>
                </div>
            </section>

            <section id="ideal-for" className="px-4 py-4 bg-black border border-blue-400 text-white">
                <h2 className="text-xl text-yellow-200 font-bold mb-2 px-4">Useful For</h2>
                <div className="space-y-6 text-white px-4">
                    <div className='text-sm'>
                        <h3 className="text-lg font-semibold mb-2">Foundation & Entrance Courses Aspirants</h3>
                        <ul className="list-disc ml-6 space-y-1">
                        <li>Mathematics and Science Foundation Courses</li>
                        <li>NTSE Preparation</li>
                        <li>Olympiad Preparation</li>
                        <li>KVPY Early Preparation</li>
                        <li>Foundation for JEE/NEET</li>
                        <li>CSAT Basics</li>
                        <li>Commerce/CA Foundation Basics</li>
                        <li>English Language Proficiency and Communication Skills</li>
                        <li>Coding and Computer Science Basics</li>
                        <li>Personality Development and Mental Ability</li>
                        </ul>
                    </div>
                    <div className='text-sm'>
                        <h3 className="text-lg font-semibold mb-2">Focus Areas</h3>
                        <ul className="list-disc ml-6 space-y-1">
                        <li>Mathematics, Science, Physics, Chemistry, Biology</li>
                        <li>Mental Ability, Social Science, Logical Reasoning</li>
                        <li>General Knowledge, Accounts, Economics, Business Studies</li>
                        <li>Grammar, Vocabulary, Essay Writing</li>
                        <li>Programming, Algorithm Design, Critical Thinking</li>
                        <li>Verbal Aptitude, Non-verbal Aptitude</li>
                        </ul>
                    </div>
                    <div className='text-sm'>
                        <h3 className="text-lg font-semibold mb-2">Popular Exams/Competitions</h3>
                        <ul className="list-disc ml-6 space-y-1">
                        <li>JEE Main, JEE Advanced, NEET</li>
                        <li>NTSE, NSO, IMO, NCO</li>
                        <li>Homi Bhabha Science Exam, Junior Science Olympiad, Math Olympiad</li>
                        <li>KVPY, CSAT, SAT, TOEFL, IELTS</li>
                        </ul>
                    </div>
                </div>
                <div className="mt-2">
                    <a href="#main-menu" className="text-yellow-200 underline hover:text-yellow-300">Go to Menu</a>
                </div>
            </section>

            <section id="students" className="bg-black border border-blue-400 p-4 text-white py-2">
                <div className="px-4 text-white">
                    <h2 className="text-xl font-semibold mb-2 text-yellow-200">Empowering Students with ThinkAIInsight</h2>
                    <p className="text-sm mb-3">
                    ThinkAIInsight aims to bridge the gap between academic preparation and competitive exam readiness for students. With a clear picture of where they stand and what steps they need to take, students can excel in their academic journey and be well-prepared for competitive exams.
                    </p>

                    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
                        <div className="bg-gray-800 p-6 rounded-lg shadow-lg text-sm">
                            <h3 className="text-lg font-semibold mb-2">For Students</h3>
                            <p className="mb-2 text-sm">Think5Whys AI Insights can help students assess their strengths and weaknesses, guiding them in their academic journey and exam preparation.</p>
                            <ul className="list-disc ml-6 space-y-2">
                            <li>Strengths in specific subjects</li>
                            <li>Weak areas to work on</li>
                            <li>Recommendations for competitive exam prep aligned with the academic syllabus</li>
                            <li>Organized Interview Prep</li>
                            </ul>
                        </div>

                        <div className="bg-gray-800 p-6 rounded-lg shadow-lg">
                            <h3 className="text-lg font-semibold mb-2">Teacher/Parent Dashboard</h3>
                            <p className="mb-2 text-sm">Teachers and parents can view the student’s progress to provide additional support and track improvements in real-time.</p>
                        </div>

                        <div className="bg-gray-800 p-6 rounded-lg shadow-lg">
                            <h3 className="text-lg font-semibold mb-2">How Students Will Benefit</h3>
                            <ul className="list-disc ml-6 space-y-2 text-sm">
                            <li><strong>Personalized Guidance:</strong> Tailored suggestions for academics, career, and well-being.</li>
                            <li><strong>Flexibility:</strong> Choose the plan that suits your lifestyle and budget.</li>
                            <li><strong>Advanced AI:</strong> Powered by cutting-edge AI algorithms for accurate and effective counselling.</li>
                            <li><strong>Accessible Anytime, Anywhere:</strong> On your desktop, tablet, or mobile.</li>
                            <li><strong>Stay Organized:</strong> Maintain a structured record of their performance.</li>
                            <li><strong>Self-Evaluation:</strong> Continuously evaluate their academic readiness.</li>
                            <li><strong>Motivation:</strong> See tangible progress and feel encouraged to improve.</li>
                            <li><strong>Bridge Gaps:</strong> Address weak areas proactively before competitive exams.</li>
                            <li><strong>Data-Driven Prep:</strong> Use past performance data to optimize competitive exam preparation.</li>
                            </ul>
                        </div>
                    </div>

                    <div className="mt-2 bg-black p-8 rounded-lg shadow-lg">
                        <h3 className="text-lg font-semibold mb-3 text-yellow-200">Common Foundation Courses</h3>
                        <p className="text-sm mb-2">Here are some common foundation courses that can help students prepare for competitive exams and build strong conceptual knowledge:</p>

                        <div className="space-y-8">
                            <div>
                                <h4 className="text-m font-semibold text-blue-400">1. Mathematics and Science Foundation Courses</h4>
                                <p className="text-sm mb-2"><strong>Focus:</strong> Strengthening concepts in Mathematics, Physics, Chemistry, and Biology.</p>
                                <p className="text-sm mb-2"><strong>Popular for:</strong> Engineering Entrance Exams: JEE (Main & Advanced), Medical Entrance Exams: NEET.</p>
                                <p className="text-sm mb-2"><strong>Institutes:</strong> FIITJEE, Aakash, Allen, Byju’s, etc.</p>
                                <p className="text-sm"><strong>Topics covered:</strong> Algebra, Geometry, Trigonometry, Mechanics, Organic Chemistry basics, etc.</p>
                            </div>

                            <div>
                                <h4 className="text-m font-semibold text-blue-400">2. NTSE (National Talent Search Examination) Preparation</h4>
                                <p className="text-sm mb-2"><strong>Focus:</strong> Advanced topics in Science, Mathematics, Mental Ability, and Social Science.</p>
                                <p className="text-sm mb-2"><strong>Objective:</strong> Winning scholarships through this prestigious program.</p>
                                <p className="text-sm mb-2"><strong>Popular among:</strong> Students in grades 9 and 10.</p>
                            </div>

                            <div>
                                <h4 className="text-m font-semibold text-blue-400">3. Olympiad Preparation</h4>
                                <p className="text-sm mb-2"><strong>Includes:</strong> Science Olympiad Foundation (SOF): NSO, IMO, NCO, etc., Homi Bhabha Science Exam, Junior Science Olympiad, Math Olympiad.</p>
                                <p className="text-sm mb-2"><strong>Focus:</strong> Deep problem-solving skills and advanced subject knowledge.</p>
                                <p className="text-sm"><strong>Levels:</strong> School, district, state, and international.</p>
                            </div>

                            <div>
                                <h4 className="text-m font-semibold text-blue-400">4. KVPY (Kishore Vaigyanik Protsahan Yojana) Early Preparation</h4>
                                <p className="text-sm mb-2"><strong>Focus:</strong> Building aptitude for scientific research and innovation.</p>
                                <p className="text-sm mb-2"><strong>Target Audience:</strong> Bright students in classes 8–10 aiming for a science/research career.</p>
                            </div>

                            <div>
                                <h4 className="text-m font-semibold text-blue-400">5. Foundation for JEE/NEET</h4>
                                <p className="text-sm mb-2"><strong>Focus:</strong> Early exposure to competitive-level questions in Physics, Chemistry, and Biology (for NEET) or Mathematics (for JEE).</p>
                                <p className="text-sm mb-2"><strong>Emphasis:</strong> Conceptual clarity, problem-solving speed, and accuracy.</p>
                                <p className="text-sm"><strong>Recommended for:</strong> Students aiming for IITs, NITs, AIIMS, etc.</p>
                            </div>

                            <div>
                                <h4 className="text-m font-semibold text-blue-400">6. CSAT Basics (Civil Services Aptitude Test)</h4>
                                <p className="text-sm mb-2"><strong>Focus:</strong> Logical reasoning, mental ability, and basic general knowledge.</p>
                                <p className="text-sm"><strong>Popular among:</strong> Students interested in early preparation for UPSC or state exams.</p>
                            </div>

                            <div>
                                <h4 className="text-m font-semibold text-blue-400">7. Commerce/CA Foundation Basics</h4>
                                <p className="text-sm mb-2"><strong>Focus:</strong> Accounts, Economics, and Business Studies.</p>
                                <p className="text-sm"><strong>Popular among:</strong> Students aspiring for CA, CS, or similar careers.</p>
                            </div>

                            <div>
                                <h4 className="text-m font-semibold text-blue-400">8. English Language Proficiency and Communication Skills</h4>
                                <p className="text-sm mb-2"><strong>Focus:</strong> Grammar, vocabulary, and essay writing.</p>
                                <p className="text-sm"><strong>Target Audience:</strong> Students preparing for exams like SAT, TOEFL, or IELTS.</p>
                            </div>

                            <div>
                                <h4 className="text-m font-semibold text-blue-400">9. Coding and Computer Science Basics</h4>
                                <p className="text-sm mb-2"><strong>Focus:</strong> Logic building, programming, and algorithm design.</p>
                                <p className="text-sm"><strong>Popular among:</strong> Students interested in technology and programming careers.</p>
                            </div>

                            <div>
                                <h4 className="text-m font-semibold text-blue-400">10. Personality Development and Mental Ability</h4>
                                <p className="text-sm"><strong>Includes:</strong> Reasoning, verbal/non-verbal aptitude, critical thinking.</p>
                                <p className="text-sm"><strong>Helps in:</strong> Preparing for exams testing IQ and interview skills.</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="mt-2">
                    <a href="#main-menu" className="text-yellow-200 underline hover:text-yellow-300">Go to Menu</a>
                </div>
            </section>

            <section id="teachers" className="bg-black border border-blue-400 p-4 text-white py-2">
                <div className="px-4 text-white">
                    <h2 className="text-xl font-semibold mb-2 text-yellow-200">Empowering Teachers with ThinkAIInsight</h2>
                    <p className="text-sm mb-3">
                    ThinkAIInsight supports teachers by providing structured tools to track student progress, identify learning gaps, and enable personalized academic interventions. Teachers get real-time insights that help improve classroom outcomes efficiently.
                    </p>

                    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
                        <div className="bg-gray-800 p-6 rounded-lg shadow-lg text-sm">
                            <h3 className="text-lg font-semibold mb-2">Teaching Insights</h3>
                            <p className="mb-2 text-sm">
                            Teachers can use AI-powered insights to understand class performance trends and optimize lesson plans.
                            </p>
                            <ul className="list-disc ml-6 space-y-2">
                            <li>Identify subject-wise gaps</li>
                            <li>Class-level performance comparison</li>
                            <li>AI-recommended teaching strategies</li>
                            <li>Interview & GD prep guidance for students</li>
                            </ul>
                        </div>

                        <div className="bg-gray-800 p-6 rounded-lg shadow-lg">
                            <h3 className="text-lg font-semibold mb-2">Class & Dashboard view</h3>
                            <p className="mb-2 text-sm">Teachers get access to smart dashboards to monitor each student’s progress in real time.</p>
                        </div>

                        <div className="bg-gray-800 p-6 rounded-lg shadow-lg">
                            <h3 className="text-lg font-semibold mb-2">How Teachers Benefit</h3>
                            <ul className="list-disc ml-6 space-y-2 text-sm">
                            <li><strong>Better Planning:</strong> Structured lesson insights.</li>
                            <li><strong>Simple Tracking:</strong> Monitor student growth patterns.</li>
                            <li><strong>AI Assistance:</strong> Automated recommendations.</li>
                            <li><strong>Less Manual Work:</strong> Automated student analytics.</li>
                            <li><strong>Improve Results:</strong> Data-backed teaching decisions.</li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div className="mt-2">
                    <a href="#main-menu" className="text-yellow-200 underline hover:text-yellow-300">Go to Menu</a>
                </div>
            </section>

            <section id="parent" className="bg-black border border-blue-400 p-4 text-white py-2">
                <div className="px-4 text-white">
                    <h2 className="text-xl font-semibold mb-2 text-yellow-200">Supporting Parents with ThinkAIInsight</h2>
                    <p className="text-sm mb-3">
                    ThinkAIInsight helps parents understand their child’s strengths, learning style, emotional needs, and academic gaps—ensuring better support at home.
                    </p>

                    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
                        <div className="bg-gray-800 p-6 rounded-lg shadow-lg text-sm">
                            <h3 className="text-lg font-semibold mb-2">Parent View</h3>
                            <p className="mb-2 text-sm">
                            Parents get clear AI-based insights about their child’s performance and well-being.
                            </p>
                            <ul className="list-disc ml-6 space-y-2">
                            <li>Subject-wise strengths/weaknesses</li>
                            <li>Progress tracking</li>
                            <li>Behavioural & emotional patterns</li>
                            <li>AI-guided home support tips</li>
                            </ul>
                        </div>

                        <div className="bg-gray-800 p-6 rounded-lg shadow-lg">
                            <h3 className="text-lg font-semibold mb-2">Holistic Development</h3>
                            <p className="mb-2 text-sm">
                            Parents can track both academic and non-academic attributes, including behavioural changes.
                            </p>
                        </div>

                        <div className="bg-gray-800 p-6 rounded-lg shadow-lg">
                            <h3 className="text-lg font-semibold mb-2">How Parents Benefit</h3>
                            <ul className="list-disc ml-6 space-y-2 text-sm">
                            <li><strong>Better Understanding:</strong> Clear insights of child's needs.</li>
                            <li><strong>Real-Time Updates:</strong> No surprises during exams.</li>
                            <li><strong>Emotional Guidance:</strong> Recognize stress & anxiety early.</li>
                            <li><strong>Structured Support:</strong> Parent action plans.</li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div className="mt-2">
                    <a href="#main-menu" className="text-yellow-200 underline hover:text-yellow-300">Go to Menu</a>
                </div>                
            </section>

            <section id="mothers" className="bg-black border border-blue-400 p-4 text-white py-2">
                <div className="px-4 text-white">
                    <h2 className="text-xl font-semibold mb-2 text-yellow-200">Empowering Mothers with ThinkAIInsight</h2>
                    <p className="text-sm mb-3">
                    ThinkAIInsight supports mothers in nurturing their child’s academic growth, emotional well-being, and future planning—even with busy schedules.
                    </p>

                    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
                        <div className="bg-gray-800 p-6 rounded-lg shadow-lg text-sm">
                            <h3 className="text-lg font-semibold mb-2">Smart Parenting Insights</h3>
                            <p className="mb-2 text-sm">
                            AI helps mothers understand children’s natural talents, habits, confidence levels, and learning preferences.
                            </p>
                            <ul className="list-disc ml-6 space-y-2">
                            <li>Child’s academic readiness</li>
                            <li>Strength–weakness mapping</li>
                            <li>Customized routines</li>
                            <li>Nurturing guidance</li>
                            </ul>
                        </div>

                        <div className="bg-gray-800 p-6 rounded-lg shadow-lg">
                            <h3 className="text-lg font-semibold mb-2">Daily Guidance</h3>
                            <p className="mb-2 text-sm">Mothers receive personalized tips on motivating, mentoring, and organizing children.</p>
                        </div>

                        <div className="bg-gray-800 p-6 rounded-lg shadow-lg">
                            <h3 className="text-lg font-semibold mb-2">Benefits for Mothers</h3>
                            <ul className="list-disc ml-6 space-y-2 text-sm">
                            <li>Track child’s holistic growth</li>
                            <li>Reduce academic stress at home</li>
                            <li>Improve child’s personality & confidence</li>
                            <li>Make better decisions for career foundation</li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div className="mt-2">
                    <a href="#main-menu" className="text-yellow-200 underline hover:text-yellow-300">Go to Menu</a>
                </div>                
            </section>

            <section id="farmers" className="bg-black border border-blue-400 p-4 text-white py-2">
                <div className="px-4 text-white">
                    <h2 className="text-xl font-semibold mb-2 text-yellow-200">Supporting Farmers with ThinkAIInsight</h2>
                    <p className="text-sm mb-3">
                    ThinkAIInsight helps farmers improve decision-making, reduce expenses, learn new opportunities, and secure their family’s future through AI-supported guidance.
                    </p>

                    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
                        <div className="bg-gray-800 p-6 rounded-lg shadow-lg text-sm">
                            <h3 className="text-lg font-semibold mb-2">Farm Planning Support</h3>
                            <p className="mb-2 text-sm">AI alerts farmers on common mistakes and improvement areas.</p>
                            <ul className="list-disc ml-6 space-y-2">
                            <li>Cost optimization guidance</li>
                            <li>Record-keeping support</li>
                            <li>Seasonal plan advice</li>
                            <li>New income opportunities</li>
                            </ul>
                        </div>

                        <div className="bg-gray-800 p-6 rounded-lg shadow-lg">
                            <h3 className="text-lg font-semibold mb-2">Family & Children Support</h3>
                            <p className="mb-2 text-sm">Farmers get guidance on children’s education, career options, and skill-building.</p>
                        </div>

                        <div className="bg-gray-800 p-6 rounded-lg shadow-lg">
                            <h3 className="text-lg font-semibold mb-2">Benefits for Farmers</h3>
                            <ul className="list-disc ml-6 space-y-2 text-sm">
                            <li>Improved farm decisions</li>
                            <li>Better financial planning</li>
                            <li>Guided education planning for children</li>
                            <li>Daily actionable farming insights</li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div className="mt-2">
                    <a href="#main-menu" className="text-yellow-200 underline hover:text-yellow-300">Go to Menu</a>
                </div>                
            </section>

            <section id="workers" className="bg-black border border-blue-400 p-4 text-white py-2">
                <div className="px-4 text-white">
                    <h2 className="text-xl font-semibold mb-2 text-yellow-200">Supporting Workers with ThinkAIInsight</h2>
                    <p className="text-sm mb-3">
                    ThinkAIInsight helps workers understand job opportunities, improve productivity, and secure financial and skill-based growth for better career stability.
                    </p>

                    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
                        <div className="bg-gray-800 p-6 rounded-lg shadow-lg text-sm">
                            <h3 className="text-lg font-semibold mb-2">Skill & Productivity Insights</h3>
                            <p className="mb-2 text-sm">
                            Workers receive AI-guided insights to identify skills, improve efficiency, and explore growth opportunities.
                            </p>
                            <ul className="list-disc ml-6 space-y-2">
                            <li>Skill gap identification</li>
                            <li>Job readiness assessment</li>
                            <li>Productivity improvement tips</li>
                            <li>Workplace guidance & recommendations</li>
                            </ul>
                        </div>

                        <div className="bg-gray-800 p-6 rounded-lg shadow-lg">
                            <h3 className="text-lg font-semibold mb-2">Workplace Dashboard</h3>
                            <p className="mb-2 text-sm">Track work efficiency and performance improvement over time.</p>
                        </div>

                        <div className="bg-gray-800 p-6 rounded-lg shadow-lg">
                            <h3 className="text-lg font-semibold mb-2">Benefits for Workers</h3>
                            <ul className="list-disc ml-6 space-y-2 text-sm">
                            <li>Better career planning</li>
                            <li>Increased skill efficiency</li>
                            <li>Job security awareness</li>
                            <li>Financial guidance & planning</li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div className="mt-2">
                    <a href="#main-menu" className="text-yellow-200 underline hover:text-yellow-300">Go to Menu</a>
                </div>                
            </section>

            <section id="msmeowners" className="bg-black border border-blue-400 p-4 text-white py-2">
                <div className="px-4 text-white">
                    <h2 className="text-xl font-semibold mb-2 text-yellow-200">Empowering MSME Owners with ThinkAIInsight</h2>
                    <p className="text-sm mb-3">
                    ThinkAIInsight provides MSME owners with actionable AI insights for business growth, operational efficiency, and market expansion.
                    </p>

                    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
                        <div className="bg-gray-800 p-6 rounded-lg shadow-lg text-sm">
                            <h3 className="text-lg font-semibold mb-2">Business Insights</h3>
                            <p className="mb-2 text-sm">
                            Evaluate business performance, monitor finances, and detect growth opportunities using AI guidance.
                            </p>
                            <ul className="list-disc ml-6 space-y-2">
                            <li>Financial planning & risk assessment</li>
                            <li>Operational efficiency tracking</li>
                            <li>Market opportunity analysis</li>
                            <li>AI-driven business recommendations</li>
                            </ul>
                        </div>

                        <div className="bg-gray-800 p-6 rounded-lg shadow-lg">
                            <h3 className="text-lg font-semibold mb-2">Team & Employee Management</h3>
                            <p className="mb-2 text-sm">Monitor employee performance and align workforce productivity with business goals.</p>
                        </div>

                        <div className="bg-gray-800 p-6 rounded-lg shadow-lg">
                            <h3 className="text-lg font-semibold mb-2">Benefits for MSME Owners</h3>
                            <ul className="list-disc ml-6 space-y-2 text-sm">
                            <li>Better decision-making</li>
                            <li>Efficient business operations</li>
                            <li>Revenue growth opportunities</li>
                            <li>Data-driven strategies</li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div className="mt-2">
                    <a href="#main-menu" className="text-yellow-200 underline hover:text-yellow-300">Go to Menu</a>
                </div>                
            </section>


            <section id="managers" className="bg-black border border-blue-400 p-4 text-white py-2">
                <div className="px-4 text-white">
                    <h2 className="text-xl font-semibold mb-2 text-yellow-200">Empowering Managers with ThinkAIInsight</h2>
                    <p className="text-sm mb-3">
                    ThinkAIInsight equips managers with AI-based dashboards to improve team performance, track KPIs, and ensure strategic business outcomes.
                    </p>

                    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
                        <div className="bg-gray-800 p-6 rounded-lg shadow-lg text-sm">
                            <h3 className="text-lg font-semibold mb-2">Team Analytics</h3>
                            <p className="mb-2 text-sm">
                            Gain insights into team performance, workflow efficiency, and project progress using AI-driven metrics.
                            </p>
                            <ul className="list-disc ml-6 space-y-2">
                            <li>Track team KPIs</li>
                            <li>Identify skill gaps</li>
                            <li>Assign resources efficiently</li>
                            <li>Monitor deadlines & deliverables</li>
                            </ul>
                        </div>

                        <div className="bg-gray-800 p-6 rounded-lg shadow-lg">
                            <h3 className="text-lg font-semibold mb-2">Strategic Planning</h3>
                            <p className="mb-2 text-sm">AI recommendations help managers optimize team performance and strategy alignment.</p>
                        </div>

                        <div className="bg-gray-800 p-6 rounded-lg shadow-lg">
                            <h3 className="text-lg font-semibold mb-2">Benefits for Managers</h3>
                            <ul className="list-disc ml-6 space-y-2 text-sm">
                            <li>Informed decision-making</li>
                            <li>Improved team productivity</li>
                            <li>Strategic goal alignment</li>
                            <li>Data-driven reporting</li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div className="mt-2">
                    <a href="#main-menu" className="text-yellow-200 underline hover:text-yellow-300">Go to Menu</a>
                </div>                
            </section>

            <section id="professionals" className="bg-black border border-blue-400 p-4 text-white py-2">
                <div className="px-4 text-white">
                    <h2 className="text-xl font-semibold mb-2 text-yellow-200">Supporting Professionals with ThinkAIInsight</h2>
                    <p className="text-sm mb-3">
                    ThinkAIInsight assists professionals in career growth, skill enhancement, and performance tracking with AI-driven recommendations and insights.
                    </p>

                    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
                        <div className="bg-gray-800 p-6 rounded-lg shadow-lg text-sm">
                            <h3 className="text-lg font-semibold mb-2">Career Guidance</h3>
                            <p className="mb-2 text-sm">
                            Personalized AI insights help professionals identify skills, optimize productivity, and pursue growth opportunities.
                            </p>
                            <ul className="list-disc ml-6 space-y-2">
                            <li>Skill gap analysis</li>
                            <li>Role advancement tips</li>
                            <li>Learning & certification recommendations</li>
                            <li>Performance tracking</li>
                            </ul>
                        </div>

                        <div className="bg-gray-800 p-6 rounded-lg shadow-lg">
                            <h3 className="text-lg font-semibold mb-2">Work-Life Optimization</h3>
                            <p className="mb-2 text-sm">Improve productivity while maintaining balance with actionable insights.</p>
                        </div>

                        <div className="bg-gray-800 p-6 rounded-lg shadow-lg">
                            <h3 className="text-lg font-semibold mb-2">Benefits for Professionals</h3>
                            <ul className="list-disc ml-6 space-y-2 text-sm">
                            <li>Career growth clarity</li>
                            <li>Enhanced skills & efficiency</li>
                            <li>Better decision-making</li>
                            <li>Long-term performance improvement</li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div className="mt-2">
                    <a href="#main-menu" className="text-yellow-200 underline hover:text-yellow-300">Go to Menu</a>
                </div>                
            </section>

            <section id="governemnt" className="bg-black border border-blue-400 p-4 text-white py-2">
                <div className="px-4 text-white">
                    <h2 className="text-xl font-semibold mb-2 text-yellow-200">Empowering Government with ThinkAIInsight</h2>
                    <p className="text-sm mb-3">
                    ThinkAIInsight provides government agencies with AI-driven insights to improve workforce planning, public welfare programs, and policy impact assessment.
                    </p>

                    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
                        <div className="bg-gray-800 p-6 rounded-lg shadow-lg text-sm">
                            <h3 className="text-lg font-semibold mb-2">Workforce & Policy Analytics</h3>
                            <p className="mb-2 text-sm">
                            Assess workforce skills, track initiatives, and improve program delivery using AI-supported data.
                            </p>
                            <ul className="list-disc ml-6 space-y-2">
                            <li>Employee performance insights</li>
                            <li>Program impact measurement</li>
                            <li>Resource allocation recommendations</li>
                            <li>Data-driven governance decisions</li>
                            </ul>
                        </div>

                        <div className="bg-gray-800 p-6 rounded-lg shadow-lg">
                            <h3 className="text-lg font-semibold mb-2">Citizen & Community Programs</h3>
                            <p className="mb-2 text-sm">
                            Track the efficiency and outcomes of citizen-centric programs with AI analytics.
                            </p>
                        </div>

                        <div className="bg-gray-800 p-6 rounded-lg shadow-lg">
                            <h3 className="text-lg font-semibold mb-2">Benefits for Government</h3>
                            <ul className="list-disc ml-6 space-y-2 text-sm">
                            <li>Enhanced policy-making decisions</li>
                            <li>Efficient program monitoring</li>
                            <li>Transparent governance</li>
                            <li>Better public service delivery</li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div className="mt-2">
                    <a href="#main-menu" className="text-yellow-200 underline hover:text-yellow-300">Go to Menu</a>
                </div>                
            </section>

            <section id="psychometric-questions" className="bg-black border border-blue-400 text-white py-4 px-4">
                <h3 className="text-xl font-semibold mb-3 text-yellow-200 px-4">Periodic Psychometric Questions</h3>
                <div class="p-6 bg-black rounded-lg shadow-lg mb-2">
                    <h2 class="text-lg font-bold text-white mb-2">Why Answering Psychometric Questions Regularly is Important</h2>
                    <p class="text-white leading-relaxed mb-2 text-sm">
                        Maintaining a periodic routine of answering psychometric questions is crucial for self-awareness and personal development. These questions encourage individuals to reflect on key areas like mental well-being, confidence, stress levels, study habits, motivation, and time management. Regular reflection helps to track subtle changes in emotional and mental states, which might otherwise go unnoticed.
                    </p>
                    <p class="text-white leading-relaxed mb-2 text-sm">
                        Over time, maintaining a history of responses offers invaluable insights into behavioral patterns, emotional triggers, and the influence of external factors such as exams or personal life stressors. This historical data helps identify early warning signs of burnout, improve study strategies, and foster resilience by highlighting areas for consistent growth.
                    </p>
                    <p class="text-white leading-relaxed text-sm">
                        Additionally, tracking progress over time builds accountability and allows for meaningful discussions with mentors or counselors. These assessments act as a mirror, providing a structured approach to addressing personal challenges and celebrating growth, empowering individuals to achieve their goals with confidence and clarity.
                    </p>
                </div>
                <div className="px-4 space-y-8">
                    <div className='px-2'>
                        <h4 className="text-m font-semibold mb-2 text-blue-300">A. General Well-being</h4>
                        <div className="space-y-4">
                            <div>
                                <p className="text-sm">How have you been feeling lately?</p>
                                <ul className="list-disc ml-6">
                                <li>Good and motivated</li>
                                <li>Okay but stressed</li>
                                <li>Overwhelmed or low</li>
                                </ul>
                            </div>
                            <div>
                                <p className="text-sm">Do you feel balanced between studies and personal life?</p>
                                <ul className="list-disc ml-6">
                                <li>Yes, I balance well</li>
                                <li>Sometimes it’s overwhelming</li>
                                <li>I feel I have no personal time</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div className='px-2'>
                        <h4 className="text-m font-semibold mb-2 text-blue-300">B. Stress and Anxiety</h4>
                        <div className="space-y-4">
                            <div className='px-2'>
                                <p className="text-sm">Do you feel anxious before exams?</p>
                                <ul className="list-disc ml-6">
                                <li>Yes, very anxious</li>
                                <li>Somewhat anxious</li>
                                <li>No, I feel confident</li>
                                </ul>
                            </div>
                            <div>
                                <p className="text-sm">How do you cope with stressful situations?</p>
                                <ul className="list-disc ml-6">
                                <li>Talk to someone I trust</li>
                                <li>Take breaks or relax</li>
                                <li>Struggle to manage stress</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div className='px-2'>
                        <h4 className="text-m font-semibold mb-2 text-blue-300">C. Confidence</h4>
                        <div className="space-y-4">
                            <div className='px-2'>
                                <p className="text-sm">Do you feel confident about your progress?</p>
                                <ul className="list-disc ml-6">
                                <li>Yes, I feel on track</li>
                                <li>I have doubts sometimes</li>
                                <li>No, I feel behind</li>
                                </ul>
                            </div>
                            <div>
                                <p className="text-m">How do you handle mistakes or failures?</p>
                                <ul className="list-disc ml-6">
                                <li>Learn from them and move on</li>
                                <li>Feel upset but try again</li>
                                <li>Lose motivation and feel discouraged</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div className='px-2'>
                        <h4 className="text-m font-semiboldmb-2 text-blue-300">D. Study Habits</h4>
                        <div className="space-y-4">
                            <div className='px-2'>
                                <p className="text-sm">Do you take breaks during study sessions?</p>
                                <ul className="list-disc ml-6">
                                <li>Yes, regularly</li>
                                <li>Sometimes, but not often</li>
                                <li>No, I study for long hours without breaks</li>
                                </ul>
                            </div>
                            <div className='px-2'>
                                <p className="text-sm">Do you have a support system (family, friends, mentors)?</p>
                                <ul className="list-disc ml-6">
                                <li>Yes, I have strong support</li>
                                <li>Somewhat, but could use more support</li>
                                <li>No, I feel alone</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div className='px-2'>
                        <h4 className="text-m font-semibold mb-2 text-blue-300">E. Motivation and Time Management</h4>
                        <div className="space-y-4">
                            <div className='px-2'>
                                <p className="text-sm">Do you feel motivated to achieve your goals?</p>
                                <ul className="list-disc ml-6">
                                <li>Yes, highly motivated</li>
                                <li>Motivated but get distracted</li>
                                <li>Struggle to stay motivated</li>
                                </ul>
                            </div>
                            <div className='px-2'>
                                <p className="text-sm">How do you manage your time for studies and other activities?</p>
                                <ul className="list-disc ml-6">
                                <li>Plan and stick to a schedule</li>
                                <li>Try but often fail to manage time</li>
                                <li>Feel overwhelmed and disorganized</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="mt-2">
                    <a href="#main-menu" className="text-yellow-200 underline hover:text-yellow-300">Go to Menu</a>
                </div>
            </section>

            <section id="tests-and-preparations" className="bg-black border border-blue-400 text-white py-4 px-4">
                <h2 className="text-xl font-bold mb-3 text-yellow-200 p-4">Think5Whys Tests & Preparation</h2>
                <p className="mb-3 px-4">
                Prepare for competitive exams like JEE, NEET, NTSE, Olympiads, and more with a structured plan designed to build strong foundations and aptitude skills, ensuring students are ready not only for their primary exams but also for various other opportunities.
                </p>
                <div className="space-y-8">
                    <div className='px-4'>
                        <h4 className="text-m font-semibold mb-2 text-blue-300">Foundation-Level Aptitude Tests</h4>
                        <p>These tests reinforce fundamental concepts and develop reasoning and problem-solving skills.</p>
                        <ul className="list-disc ml-6 space-y-2">
                        <li><strong>Quantitative Aptitude:</strong> Focus on arithmetic, algebra, and data interpretation.</li>
                        <li><strong>Logical Reasoning:</strong> Practice puzzles, series, and pattern recognition.</li>
                        <li><strong>Verbal Ability:</strong> Work on grammar, vocabulary, and comprehension.</li>
                        </ul>
                    </div>

                    <div>
                        <h4 className="text-m font-semibold mb-2 text-blue-300">Basic Science Tests</h4>
                        <p>Master key concepts in fundamental sciences to build a strong base for competitive exams.</p>
                        <ul className="list-disc ml-6 space-y-2">
                        <li><strong>Physics:</strong> Fundamental concepts and numerical reasoning.</li>
                        <li><strong>Chemistry:</strong> Periodic table, reactions, and physical chemistry.</li>
                        <li><strong>Maths:</strong> Calculus, Algebra, Coordinate Geometry.</li>
                        <li><strong>Biology:</strong> Diagrams, functions, and conceptual clarity.</li>
                        </ul>
                    </div>

                    <div>
                        <h4 className="text-m font-semibold mb-2 text-blue-300">Mock Tests for JEE & NEET</h4>
                        <p>Mock tests are critical for practicing exam patterns, time management, and understanding the difficulty level.</p>
                        <div className="space-y-4">
                        <div>
                            <h5 className="text-m font-semibold mt-2">JEE Mock Tests</h5>
                            <ul className="list-disc ml-6 space-y-2">
                                <li><strong>JEE Main-Level Mocks:</strong> Practice on NTA’s official portal or apps.</li>
                                <li><strong>JEE Advanced-Level Mocks:</strong> Available from coaching centers like Allen, Aakash, FIITJEE.</li>
                                <li><strong>Sectional Mock Tests:</strong> Physics (Mechanics, Electromagnetism, Thermodynamics), Chemistry (Organic, Inorganic, Physical), Mathematics (Calculus, Algebra, Coordinate Geometry).</li>
                            </ul>
                        </div>

                        <div>
                            <h5 className="text-m font-semibold">NEET Mock Tests</h5>
                            <ul className="list-disc ml-6 space-y-2">
                                <li><strong>Full-Length NEET Mocks:</strong> Available from NEETprep, Aakash, or official NTA sources.</li>
                                <li><strong>Biology Sectional Tests:</strong> Emphasize Botany and Zoology.</li>
                                <li><strong>Physics & Chemistry Sectional Tests:</strong> Target high-weightage topics like Thermodynamics, Electrostatics, and Organic Reactions.</li>
                            </ul>
                        </div>
                        </div>
                    </div>

                    <div>
                        <h4 className="text-m font-semibold mb-2 text-blue-300">Previous Year Papers</h4>
                        <p>Accessing previous year papers helps students understand the actual exam pattern and improve problem-solving speed.</p>
                            <div className="space-y-4">
                                <div>
                                    <h5 className="text-m font-semibold">JEE Previous Year Papers</h5>
                                    <ul className="list-disc ml-6 space-y-2">
                                        <li><strong>NTA Repository:</strong> Access JEE Main question papers from the official site.</li>
                                        <li><strong>JEE Advanced Archives:</strong> Available on IIT official portals or books like Arihant/MTG.</li>
                                    </ul>
                                </div>
                            <div>
                                <h5 className="text-m font-semibold">NEET Previous Year Papers</h5>
                                <ul className="list-disc ml-6 space-y-2">
                                    <li><strong>NEET Official Papers:</strong> Download PDFs from NTA's website.</li>
                                    <li><strong>Book References:</strong> Arihant, Disha, or Trueman’s series offer compiled papers.</li>
                                </ul>
                            </div>
                        </div>
                    </div>

                    <div>
                        <h4 className="text-m font-semibold mb-2 text-blue-300">Aptitude & Scholarship Tests (Optional But Recommended)</h4>
                        <p>These tests help measure overall aptitude and sometimes provide scholarships to support your educational journey.</p>
                        <ul className="list-disc ml-6 space-y-2">
                            <li><strong>KVPY (Kishore Vaigyanik Protsahan Yojana):</strong> For students with strong aptitude in science.</li>
                            <li><strong>NTSE (National Talent Search Examination):</strong> For students who passed 10th and want early preparation for future goals.</li>
                            <li><strong>CUET (Common University Entrance Test):</strong> For students exploring options beyond JEE/NEET.</li>
                            <li><strong>Scholarship Exams:</strong> Tests by coaching centers offering discounted fees for students.</li>
                        </ul>
                    </div>

                    <div>
                        <h4 className="text-m font-semibold mb-2 text-blue-300">Supplementary Tests for Engineering/Medical Aspirants</h4>
                        <p>These tests provide additional pathways for engineering and medical aspirants.</p>
                        <ul className="list-disc ml-6 space-y-2">
                            <li><strong>BITSAT (Birla Institute of Technology and Science Admission Test):</strong> Parallel option for engineering aspirants.</li>
                            <li><strong>VITEEE (Vellore Institute of Technology Entrance Exam):</strong> Engineering-specific test.</li>
                            <li><strong>AIIMS MBBS (NEET-Based):</strong> Focus on AIIMS-level preparation for top medical institutions.</li>
                        </ul>
                    </div>

                    <div>
                        <h4 className="text-m font-semibold mb-2 text-blue-300">General Practice Apps and Portals</h4>
                        <p>Explore these platforms for additional practice and performance analysis:</p>
                        <ul className="list-disc ml-6 space-y-2">
                            <li><strong>NTA Abhyas App:</strong> Official free mock tests for JEE and NEET.</li>
                            <li><strong>Think5Whys:</strong> Test series like Unacademy, Embibe (AI-driven analytics), Testbook.com (Sectional and topic-wise mocks).</li>
                        </ul>
                    </div>

                    <div>
                        <h4 className="text-m font-semibold mb-2 text-blue-300">Advanced Olympiads and Competitions</h4>
                        <p>Participating in these boosts confidence and adds value to college applications.</p>
                        <ul className="list-disc ml-6 space-y-2">
                            <li><strong>International Physics Olympiad (IPhO)</strong></li>
                            <li><strong>International Chemistry Olympiad (IChO)</strong></li>
                            <li><strong>International Biology Olympiad (IBO)</strong></li>
                            <li><strong>National Standard Examinations (NSEP, NSEC, NSEB)</strong></li>
                        </ul>
                    </div>

                    <div>
                        <h4 className="text-m font-semibold mb-2 text-blue-300">How to Approach These Tests</h4>
                        <ul className="list-decimal ml-6 space-y-2">
                            <li>Begin with Foundation-Level Practice: Ensure all NCERT concepts are mastered before moving to advanced questions.</li>
                            <li>Start Mock Tests Early: Gradually increase frequency as the exam date approaches.</li>
                            <li>Analyze Test Performance: Focus on weaknesses highlighted in mock results.</li>
                            <li>Incorporate Daily Aptitude Practice: Spend at least 1 hour daily on reasoning, verbal, and numerical aptitude.</li>
                        </ul>
                    </div>
                </div>
                <div className="mt-2">
                    <a href="#main-menu" className="text-yellow-200 underline hover:text-yellow-300">Go to Menu</a>
                </div>
            </section>

            <section id="progress-tracker" className="px-4 py-4 text-white bg-black border border-blue-400">
                <div className="text-white">
                    <h2 className="text-xl font-bold mb-3 text-yellow-200">My Academic Progress Tracker</h2>
                    <p className="mb-3">
                    Track your academic marks, assess your performance trends, and align your preparation for competitive exams like JEE, NEET, and more, while managing regular academic exams like Monthly Tests, Unit Tests, Term Exams, and more.
                    </p>

                    <div className="space-y-8 text-white">
                        <div className='text-white'>
                            <h4 className="text-m font-semibold mb-2">1. Exam Categories</h4>
                            <p>Students can categorize their academic exams for better tracking and focus:</p>
                            <ul className="list-disc ml-6 space-y-2">
                            <li><strong>Monthly Test:</strong> Track progress each month.</li>
                            <li><strong>Unit Test:</strong> Assess performance on individual chapters or topics.</li>
                            <li><strong>Mid-Term Exam:</strong> Evaluate understanding at the mid-point of the term.</li>
                            <li><strong>Pre-Board Exam:</strong> Simulate the final board exams for better readiness.</li>
                            <li><strong>Final Term Exam:</strong> Track overall performance at the end of the term.</li>
                            </ul>
                        </div>

                        <div>
                            <h4 className="text-m font-semibold mb-2">2. Marks Entry System</h4>
                            <p>Effortlessly input percent marks for each subject to keep track of academic progress.</p>
                            <p>Ensure consistent updates to evaluate performance accurately and make adjustments in your preparation strategy.</p>
                        </div>

                        <div>
                            <h4 className="text-m font-semibold mb-2">3. Performance Dashboard</h4>
                            <p>The performance dashboard visually represents your academic progress over time with the following tools:</p>
                            <ul className="list-disc ml-6 space-y-2">
                            <li><strong>Line Graphs:</strong> Track subject-wise marks over time to identify trends.</li>
                            <li><strong>Bar Charts:</strong> Compare results from different tests (e.g., Unit Tests vs Term Exams) to assess improvement.</li>
                            <li><strong>Scattered Graph / Heatmaps:</strong> Visually identify strengths and weaknesses in each subject.</li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div className="mt-2">
                    <a href="#main-menu" className="text-yellow-200 underline hover:text-yellow-300">Go to Menu</a>
                </div>
            </section>

            <section id="example-milestones" className="px-4 py-4 text-white bg-black border border-blue-400 text-sm">
                <div className="text-white text-sm">
                    <h2 className="text-xl font-bold mb-2 text-yellow-200">Example of Setting Milestones</h2>
                    <p className="mb-2 text-sm">
                    Setting clear milestones is essential for consistent progress. Here are 5 key milestones an IIT-JEE aspirant should aim for to optimize preparation.
                    </p>

                    <div className="space-y-8 text-sm">
                        <div>
                            <h4 className="text-sm font-semibold mt-2 text-blue-200">1. Complete NCERT Basics</h4>
                            <p className='text-sm'><strong>Description:</strong> Focus on completing NCERT books for Physics, Chemistry, and Mathematics to build a strong foundation.</p>
                            <p className='text-sm'><strong>Reason:</strong> NCERT is crucial for building basic concepts and understanding fundamental principles, especially in Chemistry.</p>
                        </div>

                        <div>
                            <h4 className="text-sm font-semibold mt-2 text-blue-200">2. Master High-Weightage Topics</h4>
                            <p className='text-sm'><strong>Description:</strong> Prioritize and master high-scoring topics like Calculus, Mechanics, Organic Chemistry, and Modern Physics.</p>
                            <p className='text-sm'><strong>Reason:</strong> These topics make up a significant portion of the IIT-JEE exam and can lead to higher scores if mastered.</p>
                        </div>

                        <div>
                            <h4 className="text-sm font-semibold mt-2 text-blue-200">3. Finish All Coaching Modules</h4>
                            <p className='text-sm'><strong>Description:</strong> Complete all modules provided by coaching classes (e.g., Allen, FIITJEE) or self-study materials by a specific deadline.</p>
                            <p className='text-sm'><strong>Reason:</strong> Coaching modules are aligned with the IIT-JEE syllabus and exam difficulty level, making them essential for exam readiness.</p>
                        </div>

                        <div className='text-sm'>
                            <h4 className="text-sm font-semibold mt-2 text-blue-200">4. Attempt 50+ Mock Tests</h4>
                            <p className='text-sm'><strong>Description:</strong> Appear for 50 or more full-length mock tests under exam-like conditions to build endurance and improve test-taking skills.</p>
                            <p className='text-sm'><strong>Reason:</strong> Mock tests help improve time management, accuracy, and stamina under pressure—key skills for performing well on exam day.</p>
                        </div>

                        <div className='text-sm'>
                            <p className="text-sm font-semibold mt-2 text-blue-200">5. Achieve Target Scores in Test Series</p>
                            <p className='text-sm'><strong>Description:</strong> Set milestones for achieving target scores in specific test series (e.g., scoring 250+ in JEE Main-level tests).</p>
                            <p className='text-sm'><strong>Reason:</strong> Monitoring progress with target scores helps boost confidence and identify areas that need more attention for improvement.</p>
                        </div>
                    </div>
                </div>
                <div className="mt-2">
                    <a href="#main-menu" className="text-yellow-200 underline hover:text-yellow-300">Go to Menu</a>
                </div>
            </section>

            <section id="rca" className="px-4 py-2 text-white bg-black border border-blue-400">
                <div className='text-white text-sm'>
                    <h2 className="text-xl font-bold mb-2 text-yellow-200">RCA - Root Cause Analysis</h2>
                    <p className='text-sm'>
                        Preparing for exams involves more than just covering the syllabus—it's about identifying and addressing the underlying challenges in your learning process. Think5Whys offers a comprehensive RCA (Root Cause Analysis) module based on the 5 Whys Analysis of Six Sigma. This structured approach helps uncover root causes of issues instead of merely applying surface-level remedies.
                    </p>
                    <p className='text-sm mt-2'>
                        By integrating RCA into your exam preparation strategy, you can:
                    </p>
                    <ul className="list-disc ml-6 space-y-2">
                        <li>Pinpoint specific obstacles in understanding key subjects.</li>
                        <li>Analyze recurring mistakes in practice tests to address the core problem.</li>
                        <li>Develop targeted solutions that lead to long-term improvement in performance.</li>
                        <li>Ensure consistent progress by resolving foundational gaps in knowledge.</li>
                    </ul>
                    <p className='text-sm mt-2'>
                        With Think5Whys' RCA module, enhance your learning efficiency and make your preparation journey more effective by addressing the root causes of setbacks.
                    </p>
                </div>
                <div className="mt-2">
                    <a href="#main-menu" className="text-yellow-200 underline hover:text-yellow-300">Go to Menu</a>
                </div>
            </section>

            <section id="interview-practice" className="px-4 py-4 text-white bg-black border border-blue-400">
                <div className='bg-gar-700 text-white'>
                    <h2 className="text-xl font-bold mb-2 text-yellow-200">Regular Interview Practice</h2>
                    <p className='text-sm mb-2'>
                        Regular interview practice is essential for a variety of exams, especially those with personal interview rounds as part of the selection process. Think5Whys AI Counselling offers structured interview preparation along with a historical progress view.
                    </p>
                    <p className='text-sm'>Here are some major exams and categories where interview preparation is crucial:</p>
                    <ul className="list-disc ml-6 space-y-2 text-sm">
                        <li>
                        <strong>Government & Administrative Services:</strong>UPSC Civil Services, State Public Service Commissions, Defence Services (e.g., SSB interviews).
                        </li>
                        <li>
                        <strong>Banking Exams:</strong> IBPS PO, SBI PO, RBI Grade B, and NABARD, focusing on banking awareness and interpersonal skills.
                        </li>
                        <li>
                        <strong>Management & Business Schools:</strong> MBA entrance exams like CAT, XAT, SNAP, and NMAT with GD, PI, and WAT components.
                        </li>
                        <li>
                        <strong>Engineering/Technology Admissions:</strong> M.Tech, PhD interviews, GATE qualifiers, and MBA-Tech programs.
                        </li>
                        <li>
                        <strong>Medical and Allied Sciences:</strong> AIIMS, JIPMER, PGIMER interviews for PG medical courses and doctoral programs.
                        </li>
                        <li>
                        <strong>Higher Education and Scholarships:</strong> Study Abroad exams (e.g., TOEFL, IELTS, GRE, GMAT) and scholarship interviews like Rhodes and Chevening.
                        </li>
                        <li>
                        <strong>Corporate Hiring via Campus Recruitment:</strong> Technical, HR, and case study interviews for top companies.
                        </li>
                        <li>
                        <strong>Specialized Exams:</strong> Law school, hotel management, civil aviation, and teaching jobs requiring interviews.
                        </li>
                    </ul>
                    <p className='text-sm mt-2'>
                        Interview practice builds confidence, improves communication skills, and enhances clarity of thought. To aid this, Think5Whys recommends a milestone-based preparation guideline tailored to each exam type:
                    </p>
                    <h3 className="text-lg font-semibold mt-2 mb-2">Milestone-Based Interview Preparation</h3>
                    <ol className="list-decimal ml-6 space-y-3 text-sm">
                        <li>
                        <strong>UPSC Civil Services:</strong> Begin with current affairs and DAF-based personal questions, proceed with mock interviews, and refine body language and stress interview techniques.
                        </li>
                        <li>
                        <strong>Banking Exams:</strong> Focus on banking terms, RBI policies, and case-based questions through structured mock interviews.
                        </li>
                        <li>
                        <strong>Defence Services:</strong> Prepare for OIR tests, group tasks, and intensive mock SSB interviews.
                        </li>
                        <li>
                        <strong>Management Exams:</strong> Develop personal stories, practice GD simulations, and refine responses to stress-based questions.
                        </li>
                        <li>
                        <strong>Study Abroad:</strong> Work on personal branding, communication skills, and university-specific mock interviews.
                        </li>
                        <li>
                        <strong>Corporate Hiring:</strong> Highlight measurable achievements in resumes, and practice problem-solving and case study interviews.
                        </li>
                    </ol>
                </div>
                <div className="mt-2">
                    <a href="#main-menu" className="text-yellow-200 underline hover:text-yellow-300">Go to Menu</a>
                </div>
            </section>

            <section id="historical-data" className="px-4 py-4 text-white bg-black border border-blue-400 text-sm">
                <div className='bg-gar-700 text-white text-sm'>
                    <h2 className="text-xl font-bold mb-2 text-yellow-200">AI Assessment</h2>
                    <p className=' text-sm mb-2'>
                        Transform your academic preparation with Think5Whys' advanced AI Assessment module. This feature provides personalized insights by leveraging AI to analyze your academic progress and performance trends. The system integrates data from your learning, planning, and analysis activities within the Think5Whys platform, creating a comprehensive and automated assessment experience.
                    </p>
                    <p className='text-yellow-200'>
                        Key Features:
                    </p>
                    <ul className="list-disc ml-6 space-y-2">
                        <li>
                        Prompt Generation: The AI generates tailored prompts to guide self-reflection and deeper analysis during self-counseling sessions.
                        </li>
                        <li>
                        Automated Insights: Using ChatGPT, the system automatically gathers and analyzes data from your activities, such as goal setting, planning, and performance reviews, to deliver actionable insights.
                        </li>
                        <li>
                        Visual Analytics: Interactive tools like line graphs for subject-wise marks, bar charts comparing test results, and heatmaps for identifying strengths and weaknesses.
                        </li>
                    </ul>
                    <p className='text-sm mt-2'>With Think5Whys' AI-driven approach, take the guesswork out of your exam preparation and empower yourself with data-backed strategies for success.</p>
                </div>
                <div className="mt-2">
                    <a href="#main-menu" className="text-yellow-200 underline hover:text-yellow-300">Go to Menu</a>
                </div>
            </section>

            <section id="historical-data" className="px-4 py-4 text-white bg-black border border-blue-400">
                <div className='bg-gar-700 text-white'>
                    <h2 className="text-xl font-bold mb-2 text-yellow-200">Historical Data</h2>
                    <p>
                        Track your academic progress and performance trends with visual insights. Manage your preparation for competitive exams alongside regular academic assessments.
                    </p>
                    <ul className="list-disc ml-6 space-y-2">
                        <li>Line graphs for subject-wise marks.</li>
                        <li>Bar charts comparing test results.</li>
                        <li>Heatmaps to identify strengths and weaknesses.</li>
                    </ul>
                </div>
                <div className="mt-2">
                    <a href="#main-menu" className="text-yellow-200 underline hover:text-yellow-300">Go to Menu</a>
                </div>
            </section>

            <section id="plans" className="px-4 py-4 bg-black border border-blue-400 text-white text-sm">
                <h2 className="text-xl font-semibold mb-2 text-yellow-200">Pricing / Plans</h2>
                
                <p className="text-sm mb-3">
                    Empowering students, professionals, and individuals with personalized guidance at their fingertips. Our AI Counselling Module is designed to address your academic, career, and mental health needs with flexible options to suit your preferences. Explore your possibilities with these exciting offerings:
                </p>
                
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
                    <div className="border p-6 rounded-lg shadow-lg bg-gray-800 text-white">
                        <h3 className="text-xl font-semibold mb-3 text-center">ThinkAIInsights COT</h3>
                        <p className="text-sm mb-2 text-center">Your gateway to self-counselling with AI prompt support.</p>
                        <p className="font-semibold text-center mb-2">Price: per self counselling</p>
                        <ul className="space-y-3 text-sm text-white">
                            <li>Uninterrupted AI-assisted self-counselling</li>
                            <li>Perfect for students or professionals seeking instant self-counselling</li>
                        </ul>
                        <p className="mt-2 text-center font-semibold text-xs text-blue-200">For users who prefer simplicity without data storage and a low-cost experience.</p>
                    </div>

                    <div className="border p-6 rounded-lg shadow-lg bg-gray-800 text-white">
                        <h3 className="text-xl font-semibold mb-3 text-center">ThinkAIInsights COB</h3>
                        <p className="text-sm mb-2 text-center">Your gateway to self-counselling with AI prompt support.</p>
                        <p className="font-semibold text-center mb-2">Price: per self counselling</p>
                        <ul className="space-y-3 text-sm text-white">
                            <li>Uninterrupted AI-assisted self-counselling</li>
                            <li>Access to Applause Module</li>
                            <li>Perfect for students or professionals seeking instant self-counselling</li>
                        </ul>
                        <p className="mt-2 text-center font-semibold text-xs text-blue-200">For users who prefer simplicity without data storage and a low-cost experience.</p>
                    </div>

                    <div className="border p-6 rounded-lg shadow-lg bg-gray-800 text-white">
                        <h3 className="text-xl font-semibold mb-3 text-center">ThinkAIInsights COS</h3>
                        <p className="text-sm mb-2 text-center">Access AI counselling sessions with added features and comparison tools.</p>
                        <p className="font-semibold text-center mb-2">Price: per self counselling</p>
                        {/* <p className="font-semibold text-center mb-2">Price 1: Rs. 10.00 (Taxes Extra)</p>
                        <p className="text-center mb-2 text-blue-400 text-xs">For securing marks {'>='} 60% in the last term exam or Government School Students or Girls (Rs. 10.00 / month paid annually Rs. 120.00 + 18% GST) for an year </p>
                        <p className="font-semibold text-center mb-2">Price 2: Rs. 15.00 (Taxes Extra)</p>
                        <p className="text-center mb-2 text-blue-400 text-xs">For securing marks 60% in the last term exam (Rs. 15.00 / month paid annually Rs. 180.00 + 18% GST) for an year </p> */}
                        <ul className="space-y-3 text-sm text-white">
                            <li>Save to History and View Progress Graphs</li>
                            <li>Access to Applause</li>
                            <li>Advanced features for students with competitive exam preparation</li>
                            <li>Exclusive premium features such as comprehensive action plans through Chronicles and advanced 5 Whys analysis</li>
                        </ul>
                        <p className="mt-2 text-center font-semibold text-xs text-blue-200">Best for those who want starter big data functionalities at a low cost.</p>
                    </div>

                    <div className="border p-6 rounded-lg shadow-lg bg-gray-800 text-white">
                        <h3 className="text-xl font-semibold mb-3 text-center">ThinkAIInsight DeepThinker</h3>
                        <p className="text-sm mb-2 text-center">Free access to all AI Counselling and advanced features without interruptions.</p>
                        <p className="font-semibold text-center mb-2">Price: per self counselling</p>
                        <p className="font-semibold text-sm text-blue-200 text-center mb-2">(Free credit is available for Think5Whys: From Why To Wisdom Digotal Immersive Book Buyer)</p>
                        <ul className="space-y-3 text-sm">
                            <li>Personalized detailed insights and history post AI-assisted counselling</li>
                            <li>Access to all modules like Applause, Chronicles, RCA, ThinkNoteFlex, Focus Timer and more</li>
                            <li>Exclusive premium features such as action plans and advanced 5 Whys analysis, Cause & Effect Fishbone Analysis</li>
                        </ul>
                        <p className="mt-2 text-center font-semibold text-xs text-blue-100">Perfect for users needing continuous, advanced data centric counselling with zero interruptions.</p>
                    </div>

                    <div className="border p-6 rounded-lg shadow-lg bg-gray-800 text-white">
                        <h3 className="text-xl font-semibold mb-3 text-center">Counsellor Connect</h3>
                        <p className="text-sm mb-2 text-center">Occasional expert counselling on-demand with no commitment.</p>
                        <p className="font-semibold text-center mb-2">Price: Variable as Per Expert</p>
                        <ul className="space-y-3 text-sm text-white">
                            <li>Pay-per-use for expert counselling</li>
                            <li>Instant access of AI counselling data to the experts</li>
                            <li>Affordable pay-per-minute pricing based on counsellor’s service rate</li>
                        </ul>
                        <p className="mt-2 text-center font-semibold text-xs text-blue-400">Ideal for those needing occasional expert advice.</p>
                    </div>
                </div>

                <div className="mt-2 text-center">
                    <p className="text-lg mb-2 text-yellow-200">Discover more about how each plan can fit your needs:</p>
                    <p className="text-sm text-white">
                    *For ThinkAIInsights COSP, pricing varies based on recent exam results. Please check for specific pricing details.
                    </p>
                </div>
                <div className="mt-2">
                    <a href="#main-menu" className="text-yellow-200 underline hover:text-yellow-300">Go to Menu</a>
                </div>
            </section>
        
            <section id="workflow" className="px-4 py-4 bg-black border border-blue-400 text-white">
                <h2 className="text-xl font-bold mb-2 text-yellow-200">Workflow / User Flow</h2>

                <h3 className="text-lg font-semibold">Steps:</h3>
                <ol className="list-decimal ml-6 space-y-2">
                    <li>Student logs into the <strong>"Think5Whys"</strong>.</li>
                    <li>Go to the <strong>"EarlySpark"</strong> module from the dashboard.</li>
                    <li>Selects the <strong>AI Counselling</strong>.</li>
                    <li>Give <strong>Psychometric Questionnaire Answers</strong>.</li>
                    <li>Input <strong>Aptitude Test Marks</strong> or pull data from the ThinkTestBook Own Test Series.</li>
                    <li>Input <strong>Academic Marks</strong> or pull data from the Academic Career Tracker for subjects.</li>
                    <li>Input <strong>Goal & Milestone</strong> or pull data from Think5Whys Career Milestone Database.</li>
                    <li>Pull <strong>Think5Whys RCA Data</strong> for previous Root Causes Analysis.</li>
                    <li><strong>AI feedback</strong> provides guidance on subjects needing attention.</li>
                    <li>Talk to <strong>counsellors from Think5Whys panels</strong> to get confirmation about AI suggestions.</li>
                    <li>Repeat the counselling process every month with Think5Whys AI Counselling program and quarterly with real counsellors on Think5Whys platform.</li>
                </ol>

                <div className="space-y-6 mt-8">
                    <h3 className="text-lg font-semibold">Miscellaneous:</h3>
                    <ul className="list-disc ml-6 space-y-2">
                        <li>Share performance data with counsellors, parents/teachers.</li>
                        <li>Dashboard updates to show trends and performance insights.</li>
                    </ul>
                </div>

                <div className="space-y-6 mt-8">
                    <h3 className="text-lg font-semibold">Additional Useful Features:</h3>
                    <ul className="list-disc ml-6 space-y-2">
                        <li><strong>Applause:</strong> Applaud or get applauded for academic efforts.</li>
                        <li><strong>Gamification:</strong> Badges for consistent improvements or high performance.</li>
                        <li><strong>Motivational Messages:</strong> Positive reinforcement messages after each entry.</li>
                        <li><strong>Compatibility:</strong> Accessible on both desktop and mobile for seamless usage.</li>
                    </ul>
                </div>
                <div className="mt-2">
                    <a href="#main-menu" className="text-yellow-200 underline hover:text-yellow-300">Go to Menu</a>
                </div>
            </section>
            <footer className="sticky bg-black border-t border-blue-400 text-white py-2 px-4 mt-2">
                <div className="flex flex-col md:flex-row justify-between items-center text-center md:text-left space-y-4 md:space-y-0">
                    <p className="text-xs sm:text-sm">&copy; 2025 Think5Whys Global DeepTech Solutions.</p>
                    <div className="flex flex-row gap-2 sm:gap-6 text-xs sm:text-sm">
                    <Link to="/about-us" className="text-white hover:text-purple-200 transition">About</Link>
                    <Link to="/privacy-policy" className="text-white hover:text-purple-200 transition">Privacy Policy</Link>
                    <Link to="/terms-of-use" className="text-white hover:text-purple-200 transition">Terms of Use</Link>
                    <Link to="/contact-us" className="text-white hover:text-purple-200 transition">Contact</Link>
                    </div>
                </div>
            </footer>      
        </div>
    );
};

export default AICounsellingAbout;

